<script>
import Layout from "@/router/layouts/main";
import { VclList } from "vue-content-loading";
import StatusBadge from "@/components/energia/StatusBadge.vue";
import StatusChecklist from "@/components/energia/StatusChecklist.vue";
import TimelineLogs from "@/components/energia/TimelineLogs.vue";
import ProgressoDots from "@/components/energia/ProgressoDots.vue";
import UploadZone from "@/components/energia/UploadZone.vue";
import { CLIENTES, INSTALACOES, getStatusGeralCliente } from "@/data/energia/mock.js";
import { formatDateBR, formatDateTimeBR } from "@/utils/energia/dates";
import { formatCpfCnpjDisplay } from "@/utils/energia/cpfCnpj";
import { api } from "@/state/services";
import moment from "moment";

function fluxoPadrao() {
  return {
    status_pdf_conta: "pendente",
    mes_referencia: "",
    valor_fatura: null,
    logradouro: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    cep: "",
    observacoes: "",
  }
}

export default {
  components: { Layout, VclList, StatusBadge, StatusChecklist, TimelineLogs, ProgressoDots, UploadZone },

  data() {
    return {
      cliente: null,
      instalacao: null,
      billPdfSubmissions: [],
      billPdfLastSubmission: null,
      contractSubmissions: [],
      contractLastSubmission: null,
      fluxoMock: fluxoPadrao(),
      logs: [],
      loading: true,
      salvandoStatus: null,
      modalPdfAberto: false,
      arquivoPdfConta: null,
      arquivoPdfContaNome: "",
      enviandoPdf: false,
      enviandoContrato: false,
      reenviandoNotificacao: false,
      excluindo: false,
      confirmando: false,
      editandoCliente: false,
      salvandoCliente: false,
      formCliente: {},
      editandoInstalacao: false,
      salvandoInstalacao: false,
      formInstalacao: {},
      checklistCliente: {
        status_dados: 'pendente',
        status_documento: 'pendente',
      },
      checklistInstalacao: {
        status_pdf_conta: 'pendente',
        status_contrato: 'pendente',
      },
    }
  },

  computed: {
    clienteMock() {
      const id = this.$route.params.id
      return CLIENTES.find(c => String(c.id) === String(id)) || null
    },

    statusGeralHeader() {
      if (!this.cliente) return 'pendente'
      return this.cliente.status
    },

    statusGeralChecklist() {
      return getStatusGeralCliente(this.checklistCliente)
    },

    progressoDots() {
      return [
        this.checklistCliente.status_dados,
        this.checklistCliente.status_documento,
        this.checklistInstalacao.status_pdf_conta,
        this.checklistInstalacao.status_contrato,
      ]
    },

    /** PDF da conta: último envio e espelho do fluxo. */
    statusPdfContaUi() {
      return this.mapStatusBillPdfFromApi(this.billPdfLastSubmission)
    },

    /** Contrato Clicksign: status vindo da API. */
    statusContratoUi() {
      return this.mapStatusContractFromApi(this.contractLastSubmission)
    },

    podeEnviarPdfConta() {
      const last = this.billPdfLastSubmission
      if (last) {
        if (last.status === "pending") return false
        if (last.status === "approved") return false
      }
      return true
    },

    podeEnviarContrato() {
      const last = this.contractLastSubmission
      if (!last) return true
      if (last.status === "pending") return false
      if (last.status === "signed") return false
      return true
    },

    /** Reenvio da notificação: só com contrato pendente e fora da janela de bloqueio (calculada no servidor). */
    podeReenviarNotificacao() {
      const last = this.contractLastSubmission
      return !!last && last.status === "pending" && last.can_resend === true
    },

    tituloBotaoContratoDesabilitado() {
      const last = this.contractLastSubmission
      if (!last) return ""
      if (last.status === "pending") {
        return "Já existe contrato aguardando assinatura. Use o link enviado ao cliente ou abra o link de assinatura."
      }
      if (last.status === "signed") return "Contrato já assinado nesta instalação."
      return ""
    },

    /** Só é possível editar dados básicos e confirmar enquanto o registro estiver "em aberto" (pós-clonagem). */
    podeEditar() {
      return !!this.cliente && this.cliente.status === "open"
    },

    /** Depois de aprovado ou inelegível, o cadastro é definitivo: não pode mais ser excluído nem clonado. */
    podeExcluir() {
      return !!this.cliente && !["approved", "ineligible"].includes(this.cliente.status)
    },
  },

  created() {
    this.carregarCliente()
  },

  methods: {
    formatDateBR,
    formatDateTimeBR,
    formatCpfCnpjDisplay,

    /**
     * Alinha status_documento com a API (pending|approved|rejected + espelho aprovado).
     * status_dados com cliente da API: sempre aprovado (cadastro já preenchido; só o documento é analisado).
     */
    mapStatusDocumentoFromApi(c) {
      if (!c) return 'pendente'
      const last = c.document_last_submission
      if (last) {
        if (last.status === 'pending') return 'enviado'
        if (last.status === 'rejected') return 'reprovado'
        if (last.status === 'approved') return 'aprovado'
      }
      const hasMirror = c.document_front_url && String(c.document_front_url).trim() !== ''
      if (hasMirror) return 'aprovado'
      return 'pendente'
    },

    syncChecklist() {
      const statusDados = this.cliente
        ? 'aprovado'
        : (this.clienteMock ? this.clienteMock.status_dados : 'pendente')
      const statusDocumento = this.cliente
        ? this.mapStatusDocumentoFromApi(this.cliente)
        : (this.clienteMock ? this.clienteMock.status_documento : 'pendente')
      this.checklistCliente = {
        status_dados: statusDados,
        status_documento: statusDocumento,
      }
      this.checklistInstalacao = {
        status_pdf_conta: this.statusPdfContaUi,
        status_contrato: this.statusContratoUi,
      }
    },

    /**
     * pending → enviado; approved → aprovado; rejected → reprovado; vazio → pendente
     */
    mapStatusBillPdfFromApi(last) {
      if (last) {
        if (last.status === "pending") return "enviado"
        if (last.status === "rejected") return "reprovado"
        if (last.status === "approved") return "aprovado"
      }
      return "pendente"
    },

    mapStatusContractFromApi(last) {
      if (last) {
        if (last.status === "pending") return "aguardando"
        if (last.status === "signed") return "assinado"
        if (last.status === "error") return "reprovado"
        if (last.status === "canceled") return "cancelado"
        if (last.status === "expired") return "reprovado"
      }
      return "pendente"
    },

    labelSubmissaoStatus(st) {
      const map = {
        pending: "EM ANÁLISE",
        approved: "APROVADO",
        rejected: "REPROVADO",
      }
      return map[st] || st
    },

    labelContratoStatus(st) {
      const map = {
        pending: "AGUARDANDO ASSINATURA",
        signed: "ASSINADO",
        error: "ERRO NO ENVIO",
        canceled: "CANCELADO",
        expired: "EXPIRADO",
      }
      return map[st] || st
    },

    syncFluxoFromMockRow(m) {
      if (!m) {
        this.fluxoMock = fluxoPadrao()
        return
      }
      this.fluxoMock = {
        status_pdf_conta: m.status_pdf_conta || "pendente",
        mes_referencia: m.mes_referencia || "",
        valor_fatura: m.valor_fatura,
        logradouro: m.logradouro || "",
        numero: m.numero || "",
        complemento: m.complemento || "",
        bairro: m.bairro || "",
        cidade: m.cidade || "",
        estado: m.estado || "",
        cep: m.cep || "",
        observacoes: m.observacoes || "",
      }
    },

    carregarInstalacao(idInstalacao) {
      return api
        .get("energy/installations/" + idInstalacao)
        .then(response => {
          if (response.data.status === "success" && response.data.installation) {
            const inst = response.data.installation
            this.instalacao = inst
            this.billPdfSubmissions = Array.isArray(inst.bill_pdf_submissions)
              ? inst.bill_pdf_submissions
              : []
            this.billPdfLastSubmission = inst.bill_pdf_last_submission || null
            this.contractSubmissions = Array.isArray(inst.contract_submissions)
              ? inst.contract_submissions
              : []
            this.contractLastSubmission = inst.contract_last_submission || null
          } else {
            this.instalacao = null
            this.billPdfSubmissions = []
            this.billPdfLastSubmission = null
            this.contractSubmissions = []
            this.contractLastSubmission = null
          }
        })
        .catch(() => {
          this.instalacao = null
          this.billPdfSubmissions = []
          this.billPdfLastSubmission = null
          this.contractSubmissions = []
          this.contractLastSubmission = null
        })
        .finally(() => {
          const m = this.instalacao
            ? INSTALACOES.find(i => String(i.id) === String(this.instalacao.id))
            : null
          this.syncFluxoFromMockRow(m)
        })
    },

    formatarMoeda(val) {
      if (!val && val !== 0) return "—"
      return "R$ " + Number(val).toFixed(2).replace(".", ",")
    },

    onPdfUploadModalChange(file) {
      this.arquivoPdfConta = file
      this.arquivoPdfContaNome = file.name
    },

    onPdfUploadRemover() {
      this.arquivoPdfConta = null
      this.arquivoPdfContaNome = ""
    },

    onPdfModalHidden() {
      this.arquivoPdfConta = null
      this.arquivoPdfContaNome = ""
    },

    validarPdfConta() {
      if (!this.arquivoPdfConta) {
        this.$toast.error("Selecione o arquivo PDF da fatura.")
        return false
      }
      return true
    },

    confirmarUploadPdfConta() {
      if (!this.instalacao || !this.podeEnviarPdfConta) return
      if (!this.validarPdfConta()) return
      this.enviandoPdf = true
      const formData = new FormData()
      formData.append("bill_pdf", this.arquivoPdfConta)

      api
        .post("energy/installations/" + this.instalacao.id + "/bill-pdf", formData)
        .then(response => {
          if (response.data.status === "success") {
            this.$toast.success(response.data.message || "PDF da conta enviado com sucesso.")
            this.modalPdfAberto = false
            this.arquivoPdfConta = null
            this.arquivoPdfContaNome = ""
            this.carregarInstalacao(this.instalacao.id).then(() => {
              this.syncChecklist()
              this.logs = this.buildActivityLogs()
            })
          } else {
            this.$toast.error(response.data.message || "Não foi possível enviar o PDF.")
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao enviar o PDF da conta, tente novamente em instantes.")
        })
        .finally(() => {
          this.enviandoPdf = false
        })
    },

    enviarContrato() {
      if (!this.instalacao || !this.podeEnviarContrato) return
      this.enviandoContrato = true
      api
        .post("energy/installations/" + this.instalacao.id + "/contract/send", {})
        .then((response) => {
          if (response.data.status === "success") {
            const link = response.data.contract && response.data.contract.sign_url
            this.$toast.success(response.data.message || "Contrato enviado para assinatura.")
            if (link) {
              window.open(link, "_blank", "noopener,noreferrer")
            }
            this.carregarInstalacao(this.instalacao.id).then(() => {
              this.syncChecklist()
              this.logs = this.buildActivityLogs()
            })
          } else {
            const link = response.data.contract && response.data.contract.sign_url
            this.$toast.warning(response.data.message || "Não foi possível enviar o contrato.")
            if (link) {
              window.open(link, "_blank", "noopener,noreferrer")
            }
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao enviar o contrato, tente novamente em instantes.")
        })
        .finally(() => {
          this.enviandoContrato = false
        })
    },

    reenviarNotificacao() {
      if (!this.instalacao || !this.podeReenviarNotificacao) return
      this.reenviandoNotificacao = true
      api
        .post("energy/installations/" + this.instalacao.id + "/contract/resend", {})
        .then((response) => {
          if (response.data.status === "success") {
            this.$toast.success(response.data.message || "Notificação reenviada.")
          } else {
            this.$toast.warning(response.data.message || "Não foi possível reenviar a notificação.")
          }
          // Recarrega para atualizar o bloqueio do botão
          this.carregarInstalacao(this.instalacao.id).then(() => {
            this.logs = this.buildActivityLogs()
          })
        })
        .catch(() => {
          this.$toast.error("Erro ao reenviar a notificação, tente novamente em instantes.")
        })
        .finally(() => {
          this.reenviandoNotificacao = false
        })
    },

    mapTimelineApiToLogs(timeline) {
      if (!Array.isArray(timeline) || !timeline.length) {
        return []
      }
      return timeline.map((t) => ({
        data: t.date_added,
        texto: t.message,
        tipo: ['ok', 'warn', 'err'].includes(t.severity) ? t.severity : 'warn',
      }))
    },

    mapDocumentSubmissionsToLogs(subs) {
      if (!Array.isArray(subs) || !subs.length) {
        return []
      }
      const labels = {
        pending: 'Enviado — em análise',
        approved: 'Documento aprovado',
        rejected: 'Documento reprovado',
      }
      return subs.map((s) => {
        let texto = `${(s.document_type || '').toUpperCase()}: ${labels[s.status] || s.status}`
        if (s.review_note) {
          texto += ` — ${s.review_note}`
        }
        return {
          data: s.date_reviewed || s.date_added,
          texto,
          tipo: s.status === 'approved' ? 'ok' : (s.status === 'rejected' ? 'err' : 'warn'),
        }
      })
    },

    sortLogsDesc(logs) {
      return [...logs].sort((a, b) => {
        const ta = new Date(a.data).getTime()
        const tb = new Date(b.data).getTime()
        if (Number.isNaN(ta) && Number.isNaN(tb)) return 0
        if (Number.isNaN(ta)) return 1
        if (Number.isNaN(tb)) return -1
        return tb - ta
      })
    },

    buildActivityLogs() {
      const subs = this.cliente && Array.isArray(this.cliente.document_submissions)
        ? this.cliente.document_submissions
        : []
      const fromTimelineCliente = this.mapTimelineApiToLogs(this.cliente && this.cliente.timeline)
      const fromSubs = this.mapDocumentSubmissionsToLogs(subs)
      const fromTimelineInstalacao = this.mapTimelineApiToLogs(this.instalacao && this.instalacao.timeline)
      const fromBillPdf = !Array.isArray(this.billPdfSubmissions) || !this.billPdfSubmissions.length
        ? []
        : this.billPdfSubmissions.map((s) => {
          const st = this.labelSubmissaoStatus(s.status)
          const nome = s.document_type === "bill_pdf" ? "PDF da conta" : "Documento"
          let texto = `${nome}: ${st}`
          if (s.review_note) {
            texto += ` — ${s.review_note}`
          }
          return {
            data: s.date_reviewed || s.date_added,
            texto,
            tipo: s.status === "approved" ? "ok" : (s.status === "rejected" ? "err" : "warn"),
          }
        })
      const fromContratos = !Array.isArray(this.contractSubmissions) || !this.contractSubmissions.length
        ? []
        : this.contractSubmissions.map((c) => {
          const st = this.labelContratoStatus(c.status)
          let texto = `Contrato: ${st}`
          if (c.error_message) {
            texto += ` — ${c.error_message}`
          }
          return {
            data: c.date_signed || c.date_added,
            texto,
            tipo: c.status === "signed" ? "ok" : (c.status === "error" ? "err" : "warn"),
          }
        })
      return this.sortLogsDesc([
        ...fromTimelineCliente,
        ...fromSubs,
        ...fromTimelineInstalacao,
        ...fromBillPdf,
        ...fromContratos,
      ])
    },

    carregarCliente() {
      this.loading = true
      const id = this.$route.params.id

      api
        .get('energy/clients/' + id)
        .then(response => {
          if (response.data.status === 'success') {
            this.cliente = response.data.client
            const installations = response.data.client.installations || []
            const idInstalacao = installations.length ? installations[0].id : null
            if (idInstalacao) {
              return this.carregarInstalacao(idInstalacao)
            }
            this.instalacao = null
          } else {
            this.cliente = null
          }
          return null
        })
        .finally(() => {
          this.loading = false
          this.syncChecklist()
          this.logs = this.buildActivityLogs()
        })
    },

    async confirmarExcluirCliente() {
      const ok = await this.$bvModal.msgBoxConfirm(
        "Serão excluídos o cliente, a instalação e todos os documentos e contratos vinculados.",
        {
          title: "Deseja realmente excluir esse cliente?",
          okTitle: "EXCLUIR",
          okVariant: "danger",
          cancelTitle: "CANCELAR",
        }
      )
      if (!ok) return

      this.excluindo = true
      api
        .post("energy/clients/" + this.cliente.id + "/delete", {})
        .then(response => {
          if (response.data.status === "success") {
            this.$toast.success(response.data.message)
            this.$router.push("/energia/clientes")
          } else {
            this.$toast.error(response.data.message)
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao excluir o cliente, tente novamente em instantes.")
        })
        .finally(() => {
          this.excluindo = false
        })
    },

    async confirmarExcluirClonarCliente() {
      const ok = await this.$bvModal.msgBoxConfirm(
        'O cadastro atual será excluído e um novo registro "Em aberto" será criado com os mesmos dados para revisão.',
        {
          title: "Deseja realmente excluir e clonar esse cliente?",
          okTitle: "EXCLUIR + CLONAR",
          okVariant: "warning",
          cancelTitle: "CANCELAR",
        }
      )
      if (!ok) return

      this.excluindo = true
      api
        .post("energy/clients/" + this.cliente.id + "/clone", {})
        .then(response => {
          if (response.data.status === "success") {
            this.$toast.success(response.data.message)
            this.$router.push("/energia/clientes/" + response.data.client.id)
          } else {
            this.$toast.error(response.data.message)
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao clonar o cliente, tente novamente em instantes.")
        })
        .finally(() => {
          this.excluindo = false
        })
    },

    labelEstadoCivil(valor) {
      const map = {
        solteiro: "Solteiro(a)",
        casado: "Casado(a)",
        divorciado: "Divorciado(a)",
        viuvo: "Viúvo(a)",
        uniao_estavel: "União estável",
        separado: "Separado(a)",
      }
      return map[valor] || valor
    },

    iniciarEdicaoCliente() {
      this.formCliente = {
        person_type: this.cliente.person_type || "pf",
        name: this.cliente.name || "",
        person_number: this.cliente.person_number || "",
        email: this.cliente.email || "",
        cellphone: this.cliente.cellphone || "",
        nationality: this.cliente.nationality || "",
        marital_status: this.cliente.marital_status || "",
      }
      this.editandoCliente = true
    },

    cancelarEdicaoCliente() {
      this.editandoCliente = false
    },

    salvarCliente() {
      const email = (this.formCliente.email || "").trim()
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        this.$toast.error("Informe um e-mail válido.")
        return
      }
      this.formCliente.email = email

      this.salvandoCliente = true
      api
        .post("energy/clients/" + this.cliente.id + "/update", this.formCliente)
        .then(response => {
          if (response.data.status === "success") {
            this.$toast.success(response.data.message)
            this.editandoCliente = false
            this.carregarCliente()
          } else {
            this.$toast.error(response.data.message)
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao salvar os dados do cliente, tente novamente em instantes.")
        })
        .finally(() => {
          this.salvandoCliente = false
        })
    },

    // Número do endereço aceita só dígitos: remove as letras digitadas e avisa
    filtrarNumeroInstalacao(event) {
      const original = event.target.value
      const digits = original.replace(/\D/g, "")

      if (digits !== original) {
        this.$toast.error('O campo número aceita apenas números. Se o endereço não tiver número, marque "Sem número".')
      }

      this.formInstalacao.number = digits
      event.target.value = digits
    },

    toggleSemNumeroInstalacao(checked) {
      this.formInstalacao.number = checked ? "S/N" : ""
    },

    iniciarEdicaoInstalacao() {
      this.formInstalacao = {
        zipcode: this.instalacao.zipcode || "",
        address: this.instalacao.address || "",
        number: this.instalacao.number || "",
        complement: this.instalacao.complement || "",
        city: this.instalacao.city || "",
        state: this.instalacao.state || "",
        distributor: this.instalacao.distributor || "",
        kwh_avg: this.instalacao.kwh_avg || "",
      }
      this.editandoInstalacao = true
    },

    cancelarEdicaoInstalacao() {
      this.editandoInstalacao = false
    },

    salvarInstalacao() {
      this.salvandoInstalacao = true
      api
        .post("energy/installations/" + this.instalacao.id + "/update", this.formInstalacao)
        .then(response => {
          if (response.data.status === "success") {
            this.$toast.success(response.data.message)
            this.editandoInstalacao = false
            this.carregarCliente()
          } else {
            this.$toast.error(response.data.message)
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao salvar os dados da instalação, tente novamente em instantes.")
        })
        .finally(() => {
          this.salvandoInstalacao = false
        })
    },

    confirmarCadastro() {
      this.confirmando = true
      api
        .post("energy/clients/" + this.cliente.id + "/confirm", {})
        .then(response => {
          if (response.data.status === "success") {
            this.$toast.success(response.data.message)
            this.carregarCliente()
          } else {
            this.$toast.error(response.data.message)
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao confirmar o cadastro, tente novamente em instantes.")
        })
        .finally(() => {
          this.confirmando = false
        })
    },

    async atualizarStatus({ campo, status }) {
      this.salvandoStatus = campo
      await new Promise(r => setTimeout(r, 600))
      this.$set(this.checklistCliente, campo, status)
      this.salvandoStatus = null
      this.logs.unshift({
        data: moment().toISOString(),
        texto: `Status de "${campo}" alterado para "${status}"`,
        tipo: status === 'aprovado' ? 'ok' : (status === 'reprovado' ? 'err' : 'warn'),
      })
      this.$toast.success('Status atualizado com sucesso!')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center">
        <router-link to="/energia/clientes" class="btn btn-sm btn-light mr-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M12.707 17.293 8.414 13H18v-2H8.414l4.293-4.293-1.414-1.414L4.586 12l6.707 6.707z"></path>
          </svg>
        </router-link>
        <div>
          <h3 class="mb-0">
            {{ cliente ? cliente.name : 'Carregando...' }}
          </h3>
          <p class="text-muted mb-0">
            Detalhe do cliente
            <template v-if="cliente">
              — <StatusBadge :status="statusGeralHeader" />
            </template>
          </p>
        </div>
      </div>
      <div v-if="cliente" class="mt-2 mt-md-0 d-flex align-items-center flex-wrap">
        <ProgressoDots :statuses="progressoDots" />
        <b-button
          v-if="podeEditar"
          size="sm"
          variant="success"
          class="ml-3"
          :disabled="confirmando"
          @click="confirmarCadastro"
        >
          Confirmar cadastro
        </b-button>
        <b-button
          v-if="podeExcluir"
          size="sm"
          variant="danger"
          class="ml-2"
          :disabled="excluindo"
          @click="confirmarExcluirCliente"
        >
          Excluir
        </b-button>
        <b-button
          v-if="podeExcluir"
          size="sm"
          variant="warning"
          class="ml-2"
          :disabled="excluindo"
          @click="confirmarExcluirClonarCliente"
        >
          Excluir + Clonar
        </b-button>
      </div>
    </div>

    <div v-if="loading">
      <vcl-list class="col-lg-6"></vcl-list>
    </div>

    <div v-else-if="!cliente" class="alert alert-danger">
      <i class="bx bx-error mr-1"></i>
      Cliente não encontrado. <router-link to="/energia/clientes">Voltar para a lista</router-link>.
    </div>

    <div v-else class="row">

      <div class="col-lg-8">

        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <h5 class="card-title mb-3">Dados do cliente</h5>
              <button
                v-if="podeEditar && !editandoCliente"
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="iniciarEdicaoCliente"
              >
                Editar
              </button>
            </div>

            <div v-if="editandoCliente" class="row">
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Tipo de pessoa</small>
                <select v-model="formCliente.person_type" class="form-control form-control-sm">
                  <option value="pf">Pessoa física</option>
                  <option value="pj">Pessoa jurídica</option>
                </select>
              </div>
              <div class="col-md-8 mb-2">
                <small class="text-muted d-block">Nome completo</small>
                <input v-model="formCliente.name" type="text" class="form-control form-control-sm" />
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">{{ formCliente.person_type === 'pj' ? 'CNPJ' : 'CPF' }}</small>
                <input v-model="formCliente.person_number" type="text" class="form-control form-control-sm" />
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Telefone</small>
                <input v-model="formCliente.cellphone" type="text" class="form-control form-control-sm" />
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">E-mail <span class="text-danger">*</span></small>
                <input v-model="formCliente.email" type="email" class="form-control form-control-sm" autocomplete="off" />
              </div>
              <div v-if="formCliente.person_type === 'pf'" class="col-md-4 mb-2">
                <small class="text-muted d-block">Nacionalidade</small>
                <input v-model="formCliente.nationality" type="text" class="form-control form-control-sm" />
              </div>
              <div v-if="formCliente.person_type === 'pf'" class="col-md-4 mb-2">
                <small class="text-muted d-block">Estado civil</small>
                <select v-model="formCliente.marital_status" class="form-control form-control-sm">
                  <option value="">—</option>
                  <option value="solteiro">Solteiro(a)</option>
                  <option value="casado">Casado(a)</option>
                  <option value="divorciado">Divorciado(a)</option>
                  <option value="viuvo">Viúvo(a)</option>
                  <option value="uniao_estavel">União estável</option>
                  <option value="separado">Separado(a)</option>
                </select>
              </div>
              <div class="col-12 mt-2 d-flex justify-content-end">
                <b-button variant="light" size="sm" class="mr-2" :disabled="salvandoCliente" @click="cancelarEdicaoCliente">
                  Cancelar
                </b-button>
                <b-button variant="primary" size="sm" :disabled="salvandoCliente" @click="salvarCliente">
                  Salvar
                  <b-spinner v-if="salvandoCliente" small class="ml-2 align-middle" variant="light" />
                </b-button>
              </div>
            </div>

            <div v-else class="row">
              <div class="col-md-8 mb-2">
                <small class="text-muted d-block">Nome completo</small>
                <span class="font-weight-semibold">{{ cliente.name }}</span>
              </div>
              <div v-if="cliente.birth_date" class="col-md-4 mb-2">
                <small class="text-muted d-block">Data de nascimento</small>
                <span>{{ formatDateBR(cliente.birth_date) || cliente.birth_date }}</span>
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">{{ cliente.person_type === 'pj' ? 'CNPJ' : 'CPF' }}</small>
                <span>{{ formatCpfCnpjDisplay(cliente.person_number) || '—' }}</span>
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Telefone</small>
                <span>{{ cliente.cellphone || '—' }}</span>
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">E-mail</small>
                <span>{{ cliente.email }}</span>
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Cadastrado em</small>
                <span>{{ formatDateTimeBR(cliente.date_added) || '—' }}</span>
              </div>
              <div v-if="cliente.person_type === 'pf' && cliente.nationality" class="col-md-4 mb-2">
                <small class="text-muted d-block">Nacionalidade</small>
                <span>{{ cliente.nationality }}</span>
              </div>
              <div v-if="cliente.person_type === 'pf' && cliente.marital_status" class="col-md-4 mb-2">
                <small class="text-muted d-block">Estado civil</small>
                <span>{{ labelEstadoCivil(cliente.marital_status) }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start">
              <h5 class="card-title mb-3">Dados da instalação</h5>
              <button
                v-if="podeEditar && instalacao && !editandoInstalacao"
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="iniciarEdicaoInstalacao"
              >
                Editar
              </button>
            </div>

            <div v-if="!instalacao" class="text-muted font-size-13">
              Instalação ainda não cadastrada para este cliente.
            </div>

            <div v-else-if="editandoInstalacao" class="row">
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Distribuidora</small>
                <input v-model="formInstalacao.distributor" type="text" class="form-control form-control-sm" />
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Média kWh</small>
                <input v-model="formInstalacao.kwh_avg" type="text" class="form-control form-control-sm" />
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">CEP</small>
                <input v-model="formInstalacao.zipcode" type="text" class="form-control form-control-sm" />
              </div>
              <div class="col-md-8 mb-2">
                <small class="text-muted d-block">Endereço</small>
                <input v-model="formInstalacao.address" type="text" class="form-control form-control-sm" />
              </div>
              <div class="col-md-2 mb-2">
                <small class="text-muted d-block">Número</small>
                <input :value="formInstalacao.number" :disabled="formInstalacao.number === 'S/N'" type="text" class="form-control form-control-sm" inputmode="numeric" @input="filtrarNumeroInstalacao" />
                <div class="custom-control custom-checkbox small mt-1">
                  <input id="sem-numero-instalacao" type="checkbox" class="custom-control-input" :checked="formInstalacao.number === 'S/N'" @change="toggleSemNumeroInstalacao($event.target.checked)" />
                  <label class="custom-control-label" for="sem-numero-instalacao">Sem número</label>
                </div>
              </div>
              <div class="col-md-2 mb-2">
                <small class="text-muted d-block">Complemento</small>
                <input v-model="formInstalacao.complement" type="text" class="form-control form-control-sm" />
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Cidade</small>
                <input v-model="formInstalacao.city" type="text" class="form-control form-control-sm" />
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">UF</small>
                <input v-model="formInstalacao.state" type="text" class="form-control form-control-sm" maxlength="2" />
              </div>
              <div class="col-12 mt-2 d-flex justify-content-end">
                <b-button variant="light" size="sm" class="mr-2" :disabled="salvandoInstalacao" @click="cancelarEdicaoInstalacao">
                  Cancelar
                </b-button>
                <b-button variant="primary" size="sm" :disabled="salvandoInstalacao" @click="salvarInstalacao">
                  Salvar
                  <b-spinner v-if="salvandoInstalacao" small class="ml-2 align-middle" variant="light" />
                </b-button>
              </div>
            </div>

            <div v-else class="row">
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Distribuidora</small>
                <span class="badge badge-soft-secondary font-size-13">{{ instalacao.distributor || "—" }}</span>
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Cód. de instalação</small>
                <span>{{ instalacao.code || "—" }}</span>
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Média kWh</small>
                <span>{{ instalacao.kwh_avg != null && instalacao.kwh_avg !== "" ? instalacao.kwh_avg : "—" }}</span>
              </div>
              <div class="col-md-4 mb-2">
                <small class="text-muted d-block">Cadastrado em</small>
                <span>{{ formatDateTimeBR(instalacao.date_added) || "—" }}</span>
              </div>
              <div v-if="fluxoMock.mes_referencia" class="col-md-4 mb-2">
                <small class="text-muted d-block">Mês de referência</small>
                <span>{{ fluxoMock.mes_referencia }}</span>
              </div>
              <div v-if="fluxoMock.valor_fatura != null" class="col-md-4 mb-2">
                <small class="text-muted d-block">Valor da fatura</small>
                <span class="font-weight-semibold">{{ formatarMoeda(fluxoMock.valor_fatura) }}</span>
              </div>

              <div v-if="instalacao.address" class="col-12 mb-2">
                <small class="text-muted d-block">Endereço</small>
                <span>
                  {{ instalacao.address }}, {{ instalacao.number }}
                  <template v-if="instalacao.complement"> — {{ instalacao.complement }}</template>
                  — {{ instalacao.city }}/{{ instalacao.state }}
                  — CEP {{ instalacao.zipcode }}
                </span>
              </div>
              <div v-else-if="fluxoMock.logradouro" class="col-12 mb-2">
                <small class="text-muted d-block">Endereço</small>
                <span>
                  {{ fluxoMock.logradouro }}, {{ fluxoMock.numero }}
                  <template v-if="fluxoMock.complemento"> — {{ fluxoMock.complemento }}</template>
                  — {{ fluxoMock.bairro }}, {{ fluxoMock.cidade }}/{{ fluxoMock.estado }}
                  — CEP {{ fluxoMock.cep }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="instalacao && fluxoMock.observacoes" class="card">
          <div class="card-body">
            <h5 class="card-title mb-2">Observações da instalação</h5>
            <p class="mb-0 text-muted">{{ fluxoMock.observacoes }}</p>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-3">Documentos a enviar</h5>
            <div v-if="!instalacao" class="text-muted font-size-13">
              Cadastre a instalação para liberar o envio de documentos.
            </div>
            <template v-else>
              <div class="table-responsive">
                <table class="table table-centered table-nowrap mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th>Documento</th>
                      <th>Descrição</th>
                      <th>Status</th>
                      <th class="text-right">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="font-weight-semibold">PDF da conta</td>
                      <td class="text-muted">Fatura de energia em PDF</td>
                      <td>
                        <StatusBadge :status="statusPdfContaUi" />
                      </td>
                      <td class="text-right">
                        <button
                          type="button"
                          class="btn btn-sm btn-primary"
                          :disabled="!podeEnviarPdfConta"
                          @click="modalPdfAberto = true"
                        >
                          <span v-if="billPdfLastSubmission && billPdfLastSubmission.status === 'rejected'">Enviar novamente</span>
                          <span v-else>Enviar documento</span>
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-semibold">Contrato</td>
                      <td class="text-muted">
                        Assinatura eletrônica
                        <a
                          v-if="contractLastSubmission && contractLastSubmission.status === 'pending' && contractLastSubmission.sign_url"
                          :href="contractLastSubmission.sign_url"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="d-block mt-1 font-size-13"
                        >Abrir link de assinatura</a>
                      </td>
                      <td>
                        <StatusBadge :status="statusContratoUi" />
                      </td>
                      <td class="text-right">
                        <div class="d-inline-flex align-items-center justify-content-end flex-wrap">
                          <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            :disabled="!podeEnviarContrato || enviandoContrato"
                            :title="tituloBotaoContratoDesabilitado"
                            @click="enviarContrato"
                          >
                            <template v-if="contractLastSubmission && contractLastSubmission.status === 'error'">
                              Tentar novamente
                            </template>
                            <template v-else>Enviar contrato</template>
                          </button>
                          <b-spinner v-if="enviandoContrato" small class="ml-2 align-middle text-primary" />
                          <button
                            v-if="contractLastSubmission && contractLastSubmission.status === 'pending'"
                            type="button"
                            class="btn btn-sm btn-outline-primary ml-2"
                            :disabled="!podeReenviarNotificacao || reenviandoNotificacao"
                            :title="podeReenviarNotificacao ? 'Reenviar a notificação de assinatura ao cliente' : 'A notificação foi reenviada recentemente. Tente novamente mais tarde.'"
                            @click="reenviarNotificacao"
                          >
                            Reenviar notificação
                          </button>
                          <b-spinner v-if="reenviandoNotificacao" small class="ml-2 align-middle text-primary" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h5 class="card-title mt-4 mb-3 ">Histórico</h5>
              <div v-if="!billPdfSubmissions.length" class="text-muted">
                Nenhum envio registrado ainda.
              </div>
              <div v-else class="table-responsive">
                <table class="table table-sm table-centered mb-0">
                  <thead class="thead-light">
                    <tr>
                      <th>Data</th>
                      <th>Status</th>
                      <th>Arquivo</th>
                      <th>Obs. da análise</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in billPdfSubmissions" :key="row.id">
                      <td class="text-nowrap">
                        {{ formatDateTimeBR(row.date_added) || "—" }}
                      </td>
                      <td>
                        <span class="badge badge-soft-secondary">{{ labelSubmissaoStatus(row.status) }}</span>
                      </td>
                      <td>
                        <a
                          v-if="row.file_url"
                          :href="row.file_url"
                          target="_blank"
                          rel="noopener noreferrer"
                        >Abrir PDF</a>
                        <span v-else class="text-muted">—</span>
                      </td>
                      <td class="text-muted">
                        {{ row.review_note || "—" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="col-lg-4">

        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-3">Status das etapas</h5>
            <p class="text-muted font-size-12 mb-2">
              <StatusBadge :status="statusGeralChecklist" />
            </p>
            <StatusChecklist
              :cliente="checklistCliente"
              tipo="cliente"
              :cliente-detalhe-id="cliente.id"
              :salvando="salvandoStatus"
              @atualizar="atualizarStatus"
            />
            <StatusChecklist
              v-if="instalacao"
              :cliente="checklistInstalacao"
              tipo="instalacao"
            />
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-3">Linha do tempo</h5>
            <TimelineLogs :logs="logs" />
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-if="instalacao"
      v-model="modalPdfAberto"
      title="Enviar PDF da conta"
      centered
      hide-header-close
      hide-footer
      @hidden="onPdfModalHidden"
    >
      <p class="text-muted mb-3">
        Envie somente o PDF da fatura de energia. O envio fica com status "em análise" até a validação.
      </p>
      <div v-if="billPdfLastSubmission && billPdfLastSubmission.status === 'rejected' && billPdfLastSubmission.review_note" class="alert alert-warning">
        <strong>Última reprovação:</strong> {{ billPdfLastSubmission.review_note }}
      </div>
      <div>
        <label class="font-weight-semibold mb-2 d-block">Arquivo</label>
        <UploadZone
          label="PDF da conta de energia"
          accept=".pdf,application/pdf"
          :max-mb="100"
          :value="arquivoPdfContaNome"
          hint="Arraste o PDF ou clique para selecionar (máx. 100MB)"
          @change="onPdfUploadModalChange"
          @remover="onPdfUploadRemover"
        />
      </div>
      <div class="d-flex justify-content-between mt-3">
        <b-button variant="light" :disabled="enviandoPdf" @click="modalPdfAberto = false">
          Cancelar
        </b-button>
        <b-button variant="primary" :disabled="enviandoPdf || !arquivoPdfConta || !podeEnviarPdfConta" @click="confirmarUploadPdfConta">
          Enviar PDF
          <b-spinner v-if="enviandoPdf" small class="ml-2 align-middle" variant="light" />
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>
